import * as React from 'react';

import { Tooltip, TooltipModel } from '@notino/react-styleguide';

import { TooltipContent } from '@components/Tags/styled';
import { ICharacteristic } from '@containers/ProductListing/model';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import {
  CharacteristicName,
  CharacteristicRow,
  CharacteristicValue,
} from './styled';

interface IProps {
  item: ICharacteristic;
  fullWidth: boolean;
}

export const Characteristic = ({
  item: { name, help, values },
  fullWidth,
}: IProps) => {
  const [isHover, setIsHover] = React.useState(false);
  const newPdDesignEnabled = useNewPdDesignEnabled();
  const charName = (
    <CharacteristicName
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      isTooltip={!!help}
      newPdDesignEnabled={newPdDesignEnabled}
    >
      {name}
    </CharacteristicName>
  );

  return (
    <CharacteristicRow fullWidth={fullWidth}>
      {help && isHover ? (
        <Tooltip
          wrapText={true}
          position={TooltipModel.Position.topRight}
          content={<TooltipContent>{help}</TooltipContent>}
        >
          {charName}
        </Tooltip>
      ) : (
        charName
      )}

      <CharacteristicValue newDesign={newPdDesignEnabled}>
        {values.join(', ')}
      </CharacteristicValue>
    </CharacteristicRow>
  );
};
